export const UPDATE_VIEW = 'UPDATE_VIEW';